module.exports = __webpack_public_path__ + "img/banner.6702347c.png";